/* Markeking — utilidades compartidas: dinero y carrito */
(function () {
  'use strict';

  function withDelimiters(cents, decimals, thousands, decimal) {
    var value = (cents / 100).toFixed(decimals);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function formatMoney(cents, format) {
    var pattern = format || (window.mkTheme && window.mkTheme.moneyFormat) || '€{{amount_with_comma_separator}}';
    cents = Math.round(Number(cents) || 0);
    return pattern.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withDelimiters(cents, 2, ',', '.');
        case 'amount_no_decimals': return withDelimiters(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelimiters(cents, 2, "'", '.');
        case 'amount_with_space_separator': return withDelimiters(cents, 2, ' ', ',');
        default: return withDelimiters(cents, 2, ',', '.');
      }
    });
  }

  function refreshCartCount() {
    return fetch((window.mkTheme ? window.mkTheme.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-mk-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        return cart;
      })
      .catch(function () {});
  }

  window.mkMoney = formatMoney;
  window.mkRefreshCartCount = refreshCartCount;
})();
